import { UnidadesTab } from '@/features/unidades';

export default function Unidades() {
  return <UnidadesTab />;
}
